import "./form-package-activity.scss";

import { PackageActivityFormSchema } from "@factory/form/form.rule";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

import useAutocompleteActivity from "../../activity/autocomplete-activity/autocomplete-activity";

type InputFormSchema = PackageActivityFormSchema;
export function FormPackageActivity() {
  const { control, setValue, getValues } =
    useFormContext<PackageActivityFormSchema>();
  const { packageId } = useParams();
  const { formElement: autocompleteActivity } = useAutocompleteActivity(
    getValues("activity") || "",
    "activity",
    "Activity",
    "Search activity",
    (selectedActivity) => {
      if (selectedActivity) {
        setValue("activity", selectedActivity.value);
      } else {
        setValue("activity", "");
      }
    }
  );
  setValue("package", packageId || "");
  return (
    <div id="FormPackageActivity" className="package-activity">
      {autocompleteActivity}
      {/* <InputControl<InputFormSchema>
        control={control}
        name="activity"
        label="Activity"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter activity"
      /> */}
    </div>
  );
}

export default FormPackageActivity;
